<template>
  <BModal
    id="modal-tambah-credential"
    centered
    hide-footer
    hide-header-close
    no-close-on-backdrop
    size="md"
    header-class="border-0 pb-0 pt-2 bg-white"
    body-class="px-2 pb-2 pt-2"
  >
    <template #modal-title>
      <span class="h3 text-dark font-weight-bold">Tambah Data Credential</span>
    </template>

    <ValidationObserver ref="formObserver">
      <!-- Nama Platform -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          Nama Platform<span class="text-danger">*</span>
        </template>

        <ValidationProvider
          v-slot="{ errors }"
          name="Nama Platform"
          rules="required|max:50|platform_name"
        >
          <BFormInput
            v-model="form.platform"
            placeholder="Nama Platform"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
          />
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- URL Platform -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          URL Platform<span class="text-danger">*</span>
        </template>
        <ValidationProvider
          v-slot="{ errors }"
          name="URL Platform"
          rules="required|platform_url"
        >
          <BFormInput
            v-model="form.loginUrl"
            placeholder="Masukkan URL platform"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
          />
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- Username/Email -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          Username/Email<span class="text-danger">*</span>
        </template>
        <ValidationProvider
          v-slot="{ errors }"
          name="Username/Email"
          rules="required|min:3|max:100"
        >
          <BFormInput
            v-model.trim="form.email"
            placeholder="Masukkan Username/Email"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
          />
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- Password -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          Password<span class="text-danger">*</span>
        </template>
        <ValidationProvider
          v-slot="{ errors }"
          name="Password"
          rules="required|min:1|max:255"
        >
          <div class="position-relative">
            <BFormInput
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Masukkan password"
              :state="errors.length > 0 ? false : null"
              :style="errors.length > 0 ? 'background-image: none' : ''"
              style="padding-right: 2.5rem;"
            />
            <button
              type="button"
              class="btn btn-link p-0 position-absolute"
              style="right: 10px; top: 50%; transform: translateY(-50%); color: #6c757d;"
              tabindex="-1"
              @click="showPassword = !showPassword"
            >
              <BIcon :icon="showPassword ? 'eye-slash' : 'eye'" />
            </button>
          </div>
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- Kategori -->
      <BFormGroup class="mb-2">
        <template
          #label
        >
          Kategori<span class="text-danger">*</span>
        </template>
        <ValidationProvider
          ref="categoryProvider"
          v-slot="{ errors }"
          name="Kategori"
          rules="required"
        >
          <div @blur.capture="onCategoryBlur">
            <BFormSelect
              v-model="form.category"
              :options="categories"
              value-field="value"
              text-field="label"
              :state="errors.length > 0 ? false : null"
              :style="errors.length > 0 ? 'background-image: none' : ''"
              class="custom-select-arrow"
              :class="{ 'placeholder-active': !form.category }"
            >
              <template #first>
                <BFormSelectOption
                  value=""
                  disabled
                  hidden
                >
                  Pilih kategori
                </BFormSelectOption>
              </template>
            </BFormSelect>
          </div>
          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>
        </ValidationProvider>
      </BFormGroup>

      <!-- Catatan -->
      <BFormGroup
        label="Catatan (Opsional)"
        class="mb-2"
      >
        <ValidationProvider
          v-slot="{ errors }"
          name="Catatan"
          rules="max_custom:500"
        >
          <BFormTextarea
            v-model="form.note"
            class="no-scrollbar"
            placeholder="Masukkan catatan tambahan seperti informasi PIN, atau pihak yang memegang OTP dan 2FA"
            rows="10"
            :state="errors.length > 0 ? false : null"
            :style="errors.length > 0 ? 'background-image: none' : ''"
          />

          <small
            class="text-danger d-flex align-items-center"
            style="gap: 4px;"
          >
            <img
              v-if="errors[0]"
              src="https://storage.googleapis.com/komerce/assets/icons/danger-red.svg"
              width="14"
              height="14"
            >
            {{ errors[0] }}
          </small>

          <div class="d-flex justify-content-end">
            <small :class="form.note.length >= 500 ? 'text-danger' : 'text-muted'">
              {{ form.note.length }}/500
            </small>
          </div>
        </ValidationProvider>
      </BFormGroup>

      <!-- Buttons -->
      <div
        class="d-flex"
        style="gap: 10px;"
      >
        <BButton
          variant="link"
          class="button-orange w-50"
          @click="handleCancle"
        >
          Batal
        </BButton>
        <BButton
          variant="link"
          :class="isFormFilled ? 'button-orange-active' : 'button-disabled'"
          class="w-50"
          :disabled="!isFormFilled || loading"
          @click="handleAdd"
        >
          <BSpinner
            v-if="loading"
            small
          />
          <span v-else>Tambah</span>
        </BButton>
      </div>
    </ValidationObserver>
  </BModal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { CATEGORIES_CREDENTIAL, credentialAxios } from './config'

export default {
  name: 'ModalTambahCredential',

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  emits: ['submitted', 'pin-expired-check', 'pin-session-expired', 'submit-error'],

  data() {
    return {
      loading: false,
      showPassword: false,
      categories: CATEGORIES_CREDENTIAL,

      form: {
        platform: '',
        loginUrl: '',
        email: '',
        password: '',
        category: null,
        note: '',
      },
    }
  },

  computed: {
    isFormFilled() {
      return !!(
        this.form.platform
        && this.form.loginUrl
        && this.form.email
        && this.form.password
        && this.form.category
      )
    },
  },

  methods: {
    async handleAdd() {
      const valid = await this.$refs.formObserver.validate()
      if (!valid) return

      this.$emit('pin-expired-check', {
        onValid: () => this.submitData(),
      })
    },

    async onCategoryBlur() {
      if (!this.form.category) {
        await this.$refs.categoryProvider.validate(null)
      }
    },

    buildPayload() {
      return {
        platform_name: this.form.platform,
        platform_url: this.form.loginUrl,
        identifier: this.form.email,
        password: (this.form.password),
        category: this.form.category,
        notes: this.form.note,
      }
    },

    async submitData() {
      this.loading = true
      const payload = this.buildPayload()

      try {
        await credentialAxios.post(
          'v1/credential_management/secure', payload,
        )

        this.$emit('submitted')
        this.hide()
      } catch (err) {
        if (err.response?.status === 403) {
          this.hide()
          this.$emit('pin-session-expired', {
            onValid: () => this.submitData(),
          })
          return
        }
        this.$emit('submit-error', err)
      } finally {
        this.loading = false
      }
    },

    handleCancle() {
      this.reset()
      this.hide()
    },

    reset() {
      this.form = {
        platform: '',
        loginUrl: '',
        email: '',
        password: '',
        category: '',
        note: '',
      }
      this.showPassword = false
      this.loading = false
      if (this.$refs.formObserver) this.$refs.formObserver.reset()
    },

    show() {
      this.reset()
      this.$bvModal.show('modal-tambah-credential')
    },

    hide() {
      this.$bvModal.hide('modal-tambah-credential')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './CredentialManagement.scss';

::v-deep select.custom-select.placeholder-active {
  color: #aab0b6 !important;
}
</style>
